import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var NoContentError = function NoContentError() {
    _classCallCheck(this, NoContentError);
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/no-content.js
// module id = ./src/abstractions/errors/no-content.js
// module chunks = 34